<template>
    <!-- Modal pour les affectations de facteurs -->
    <Factors :ref="'Factors'"
             :CheckedNodeIds="checkedNodeIds"
             :FactorLabel="FactorLabel"
             :Allocations="allocations"
             :ObjectTypes="objectTypes"
             :Variant="Variant"
             @ClosedEvent="factorsVisible = false"
             @ApplyedEvent="applyedEvent"
             :SelectedNode.sync="selectionNode" /> <!-- factorBlockFeature().GoPrevious() | factorBlockFeature().GoNext() -->
            
</template>

<script lang="ts">
	import { Component } from 'vue-property-decorator';

    import TreeNode from '@/types/TreeNode';
    import IFactorBlockFeature from '@/interfaces/Config/Factor/IFactorBlockFeature';
	import Factor from '@/types/Config/Factor/Evolution/Factor';
    import BaseFactorBlock, { DataAutoNodeChecker } from '../BaseFactorBlock';
    import Factors from '../Factors.vue';
    // import InitState from './States/InitState';

    /** Block de paramétrage de facteur pour la fonction analysis Evolution */
    @Component({
        components: {
			Factors
        }
    })
    export default class FactorBlock extends BaseFactorBlock<Factor> implements IFactorBlockFeature {
        /** Mise à jour du facteur */
        public UpdateSynFactor() {
            this.factor.AutoFilter = this.autoFilter;
            this.factor.InWarning = this.inWarning;
            this.factor.Filters = this.checkedNodeIds;
        }

        /** Permet de remettre les valeurs par défaut pour les affectations du facteur*/
		public SetAutoMode() {
            let data: DataAutoNodeChecker = this.autoNodesChecker(this.InvolvedNodes);

            this.autoFilter = true;
            this.checkedNodeIds = data.AutoCheckedNodeIds;
            this.inWarning = data.InWarning;

            // Mie à jour du facteur
            this.UpdateSynFactor();
		}

        /**
         * Méthode appelé lors de l'émission de l'event ApplyedEvent
         * @param args Liste des arguments
         */
        public applyedEvent(args){
            this.UpdateCheckedNodes(args["selectionNode"], args["checkedNodeIds"]);
        }

        /** Met à jour la liste des noeuds cochés
         * @param selectionNode noeud selectionné ou nul
         * @param checkedNodeIds Liste des noeuds à cocher
         */
        public UpdateCheckedNodes(selectionNode: TreeNode, checkedNodeIds: string[]) {
            let data: DataAutoNodeChecker = this.autoNodesChecker(this.InvolvedNodes);

            // Comparaison entre la liste des noeuds à cocher et la liste automatique des noeuds sélectionnés
			this.autoFilter = this.compareListes(checkedNodeIds, data.AutoCheckedNodeIds);
			this.checkedNodeIds = checkedNodeIds;

			// Si mode manuel, on désactive le mode erreur
			if(!this.autoFilter)
				this.inWarning = false;

            // Mise à jour du facteur
            this.UpdateSynFactor();

            /** Désactive le composant Factors.vue */
            this.factorsVisible = false;
        }

        public UpdateByInvolvedNodes(val: TreeNode[]){
            this.involvedNodes = val;
            console.debug("Evolution/FactorBlock - val : %O, objectTypes : %O - allocations : %O ", val);
            let data: DataAutoNodeChecker = this.autoNodesChecker(val);
            console.debug("Evolution/FactorBlock - data : %O ", data);

            // Si mode automatique, on affecte à la sélection des noeuds à cocher 
            if(this.autoFilter)
                this.checkedNodeIds = data.AutoCheckedNodeIds;

            // Mise à jour de la valeur du mode erreur pour le composant
            this.inWarning = data.InWarning;

            // Mise à jour du facteur sélectionné
            this.UpdateSynFactor();
        }

        /** 
         * Affiche la modale Factors
         * @description Implémentation de la méthode issue de l'interface IFactorBlockFeature
         * @description Appelé depuis FactorBlock.vue parent
         */
        public StartSelection() {
            (this.$refs['Factors'] as Factors).StartSelection(undefined, this.factor.Filters);
        }

        // created() {
            /** Initialisation dynamique de la machine d'état spécialisée pour la feature analysis en cours */
            // this.TransitionTo(new InitState());
        // }
    }
</script>

<style scoped>

</style>